import Pac from "./components/Pac";
import getPacActions from "./promises/getPacActions";
export default Pac;
export { getPacActions };